import React, { useState, useEffect } from "react";
import { isMobile } from 'react-device-detect';
import { toast } from 'react-toastify';
import { IEmployeeProgression } from "../model/EmployeeProgression.model";
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { ISkill } from "../model/Skill.model";
import SkillDivider from "../components/skillpath/SkillDivider";
import { ISkillPath } from "../model/SkillPath.model";
import DesktopSkillGrid from "../components/skillpath/DeskTopSkillGrid";
import { ISkillLevel } from "../model/SkillLevel.model";
import { Icon } from "../components/icons/icons";
import { useParams } from "react-router-dom";
import LevelIcon from "../components/skillpath/LevelIcon";
import useWindowDimensions from "../hooks/windowDimensions";
import MobileSkillView from "../components/skillpath/MobileSkillView";
import '../styles/pages/EmployeeProgression.scss';
import { IEmployeeProgressionLevel } from "../model/EmployeeProgressionLevel.model";

const EmployeeProgression = () => {
    const [isMobileClient, setIsMobileClient] = React.useState<boolean>(false);
    const { height, width } = useWindowDimensions();
  const { upn } = useParams();
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [employeeProgressions, setEmployeeProgressions] = useState<
    IEmployeeProgression[]
  >([]);
  const [employeeProgressionLevels, setEmployeeProgressionLevels] = useState<
    IEmployeeProgressionLevel[]
  >([]);
  const [typeFilter, setTypeFilter] = useState<string>("");
  const [empsLoaded, setEmpsLoaded] = useState<boolean>(false);
  const [skillTree, setSkillTree] = useState<ISkillPath[]>([]);
  const [skillTreeLoaded, setSkillTreeLoaded] = useState<boolean>(false);
  const [currentUpn, setCurrentUpn] = useState<string | undefined>(upn);
  const [currentEmp, setCurrentEmp] = useState<any>(null);
  if (currentUpn!==upn) {
    setSkillTree([]);
    setSkillTreeLoaded(false);
    setEmployeeProgressions([]);
    setEmpsLoaded(false);
    setCurrentUpn(upn);
  }
  useEffect(() => {
    const finalValue = isMobile || width < 1100;
    setIsMobileClient(finalValue);
}, [width]);
  useEffect(() => {
    if (!account) return;
    if (skillTreeLoaded) return;
    let apiSTUrl = `/api/EmpProgs/SkillTree`;
    if (upn) {
      apiSTUrl = `/api/SupEmpProg/SkillTree/${upn}`;
    }
    execute("GET", apiSTUrl, undefined)
      .then((response) => {
        if (!response) {
          //alert('error undefined');
          return;
        }
        if (response.error) {
          //alert(response.error)
          return;
        }
        setSkillTree(sortSkillTree(response.skillPaths, employeeProgressions, employeeProgressionLevels));
        setCurrentEmp(response.employee);
        setSkillTreeLoaded(true);
      })
      .catch((err: any) => {
        debugger;
      });
  }, [skillTree, skillTreeLoaded, account, execute, instance, upn]);
  const sortSkillTree = (skillPaths:ISkillPath[], employeeProgressions:IEmployeeProgression[], employeeProgressionLevels:IEmployeeProgressionLevel[] = []) => {
    // give all skills their own version of skillgroup and skillpath
    const conflatedSkillPaths: ISkillPath[] = [];
    //const skillMap = new Map<string, any>();
    skillPaths.forEach(sp => {
      if (sp.skillGroups) {
        sp.skillGroups.forEach(sg => {
          if (sg.skills) {
            sg.skills.forEach(s => {
              var sp1 = JSON.parse(JSON.stringify(sp));
              var sg1 = JSON.parse(JSON.stringify(sg));
              sp1.skillGroups = [sg1];
              sg1.skills = [s];
              conflatedSkillPaths.push(sp1);

              //skillMap.set(s.SkillId, { ...s, skillGroupId: sg.skillGroupId, skillPathId: sp.skillPathId });
            });
          }
        });
      }
    });
    conflatedSkillPaths.sort((a: ISkillPath, b: ISkillPath) => {
      var skill = a.skillGroups![0].skills![0];
      var skill2 = b.skillGroups![0].skills![0];
      if (skill && skill2) {
        var bm = employeeProgressions.find(ep => ep.skillId === skill.SkillId);
        var masteredCount1 = employeeProgressionLevels.filter(level => level.skillId === skill.SkillId && level.stage==="M").length;
        var masteredCount2 = employeeProgressionLevels.filter(level => level.skillId === skill2.SkillId && level.stage==="M").length;
        var masteredConfirmedCount1 = employeeProgressionLevels.filter(level => level.skillId === skill.SkillId && level.stage==="MC").length;
        var masteredConfirmedCount2 = employeeProgressionLevels.filter(level => level.skillId === skill2.SkillId && level.stage==="MC").length;
        if (masteredConfirmedCount1 > masteredConfirmedCount2 && masteredConfirmedCount2 === 3) {
          return -1;
        }
        if (masteredConfirmedCount2 > masteredConfirmedCount1 && masteredConfirmedCount1 === 3) {
          return 1;
        }
        if (masteredCount1 > 1 && masteredCount2 === 0) {
          return -1;
        }
        if (masteredCount2 > 1 && masteredCount1 === 0) {
          return 1;
        }
        if (masteredConfirmedCount1 > 1 && masteredConfirmedCount2 === 0) {
          return 1;
        }
        if (masteredConfirmedCount2 > 1 && masteredConfirmedCount1 === 0) {
          return -1;
        }
        if (masteredCount1 > masteredCount2) {
          return -1;
        }
        if (masteredCount2 > masteredCount1) {
          return 1;
        }
      }
      return 0;
    });
    conflatedSkillPaths.forEach((value) => {
      console.log(`Skill with path: `, value);
    });
    const sortedSkillPaths = skillPaths.sort((a, b) => {
      if (a.indexNumber < b.indexNumber) {
        return -1;
      }
      if (a.indexNumber > b.indexNumber) {
        return 1;
      }
      return 0;
    });
    skillPaths.forEach(sp => {
      if (sp.skillGroups) {
        sp.skillGroups = sp.skillGroups.sort((a, b) => {
          if (a.indexNumber < b.indexNumber) {
            return -1;
          }
          if (a.indexNumber > b.indexNumber) {
            return 1;
          }
          return 0;
        });
      }
    });
    return conflatedSkillPaths;
  }
  useEffect(() => {
    if (!skillTreeLoaded || empsLoaded) return;
    let apiProgsUrl = `/api/EmpProgs`; ///SupEmpProg/List/
    if (upn) {
      apiProgsUrl = `/api/SupEmpProg/List/${upn}`; ///SupEmpProg/List/
    }
    execute("GET", apiProgsUrl, undefined)
      .then((response) => {
        if (!response) {
          //alert('error undefined');
          return;
        }
        if (response.error) {
          //alert(response.error)
          return;
        }
        var progressions = response.progressions;
        var levels = response.levels;
        setEmployeeProgressions(progressions);
        setEmployeeProgressionLevels(levels);
        setSkillTree(sortSkillTree(skillTree, progressions, levels));
        setEmpsLoaded(true);
        /*var stFrag = response.reduce((v:string,cv:IEmployeeProgression, i:number) => {
        if (v.length===0) return "SkillId eq '" +cv.skillId + "'";
        return `${v} or SkillId eq '${cv.skillId}'`;
      }, "");
      setSkillOdataString(stFrag);*/
      })
      .catch((err: any) => {
        debugger;
      });
  }, [skillTreeLoaded, empsLoaded, account, execute, upn]);
  const HandleProgressionLevelAdded = (progressionLevel:any) => {
    console.log('handle progression level added', progressionLevel);
    employeeProgressionLevels.push(progressionLevel);
    setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
  };
  const HandleProgressionLevelRemoved = (progressionLevelId:any) => {
    console.log('handle progression level removed', progressionLevelId);
    const index = employeeProgressionLevels.findIndex(ep => ep.employeeProgressionLevelId === progressionLevelId);
    if (index > -1) {
      employeeProgressionLevels.splice(index, 1);
      setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
    }
  };
  const HandleProgressionLevelUpdated = (progressionLevel:any) => {
    console.log('handle progression level updated', progressionLevel);
    const index = employeeProgressionLevels.findIndex(ep => ep.employeeProgressionLevelId === progressionLevel.employeeProgressionId);
    if (index > -1) {
      employeeProgressionLevels[index] = progressionLevel;
      setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
    }
  };
  const handleMarkReviewed = () => {
    if (!upn) return;
    execute("POST", `/api/EmpProg/markReviewed/${upn}`, undefined)
      .then((response) => {
        if (!response || response.error) {
          return;
        }
        setCurrentEmp((prev: any) => prev && ({
          ...prev,
          lastReviewedDate: response.lastReviewedDate,
          reviewedBy: response.reviewedBy,
        }));
        toast.success('Marked as reviewed.');
      })
      .catch((err: any) => {
        debugger;
      });
  }
  const HandleBookmarkRemoved = (bookmark:IEmployeeProgression) => {
    console.log('handle bookmark removed', bookmark);
    employeeProgressions.forEach(ep => {
      if (ep.employeeProgressionId === bookmark.employeeProgressionId) {
        employeeProgressions.splice(employeeProgressions.indexOf(ep), 1);
        setEmployeeProgressions(JSON.parse(JSON.stringify(employeeProgressions)));
      }
    });
    console.log('skilltree', skillTree);
    //debugger;
  }
  const showSkill = (skill:ISkill) => {
    if (typeFilter==="") return true;
    let bmstate = employeeProgressions.some(ep => ep.skillId === skill.SkillId);
    let masterState = employeeProgressionLevels.some(ep => ep.skillId === skill.SkillId && (ep.stage === "M"));
    let masterConfirmedLength = employeeProgressionLevels.filter(ep => ep.skillId === skill.SkillId && ep.stage === "MC").length;
    if (typeFilter === "B" && bmstate) return true;
    if (typeFilter === "M" && masterState) return true;
    if (typeFilter === "MC" && masterConfirmedLength > 0) return true;
    if (typeFilter === "F" && masterConfirmedLength > 2) return true;
    return false;
  }
  const getFilter = () => {
    function HandleSetTypeFilter(value: string): void {
      setTypeFilter(value);
      //var filtered = employeeProgressions.filter(ep => ep.stage === value);
      //if (value==="") filtered = employeeProgressions.filter(x => 1===1);
      /*var filtered = JSON.parse(JSON.stringify(skillTree));
      filtered = filtered.map((sp:any) => {
        sp.skillGroups = sp.skillGroups.map((sg:any) => {
          sg.skills = sg.skills.filter((s:any) => {
            return employeeProgressions.some(ep => ep.skillId === s.SkillId && ep.stage === value);
          });
          return sg;
        });
        return sp;
      });*/
      //setEmployeeFilteredProgressions(filtered);
    }

 return <>
          <label htmlFor="filter-select" style={{ fontWeight: 900 }}>Filter: </label>
          <br/>
          <select id="filter-select" onChange={e => HandleSetTypeFilter(e.target.value)}>
            <option value="" selected>All</option>
            <option value="B" >Bookmarked</option>
            <option value="M">Mastered</option>
            <option value="MC">Mastered Confirmed</option>
            <option value="F">Fully Mastered</option>
          </select>
        </>
  }
  const getDividerText = (skillpathName:string, skillGroupName: string, skillName: string) => {
    return skillpathName + " : " + skillGroupName + " : " + skillName;
  };

  const getUL = () => {
    return (
      <ul className="reset">
        <li className="ep-bookmark-li">
          <Icon name="icon-chat-bullet-white" className="ep-icon-chat" />
          <p className="m-t--50 m-b--50">Speak to your manager about opportunities to develop these skills.</p>
        </li>
        <li className="ep-bookmark-li">
          <Icon name="icon-email" className="ep-icon-email" />
          <p className="m-t--50 m-b--50">Connect with the Learning & Development team for relevant learning resources available to you.</p>
        </li>
        <li className="ep-bookmark-li">
          <Icon name="icon-pencil" className="ep-icon-pencil icon-white" />
          <p className="m-t--50 m-b-0">Develop and input goals into your UKG Goal Platform.</p>
        </li>
      </ul>
    )
  }
  const getH3Heading = () => {
    return (
      <>
        <h3 className="fnt-wght-bold m-b-1 m-t-0 h1-size">My Skill Inventory</h3>
        <p>Bookmark skills to track progress. Click "Mastered" when ready for manager review.<br/> Use the dropdown to switch between Bookmarked, Mastered (not confirmed), Mastered Confirmed, Fully Mastered (all levels confirmed) or All. </p>
      </>
    )
  }

  const getH2Heading = () => {
    return (
      <>
      <h2 className="fnt-wght-bold m-b-1 h1-size">{currentEmp.fullName} - Skill Inventory</h2>
      <p>Skills that have been bookmarked and mastered appear here.<br/> Use the dropdown to switch between Bookmarked, Mastered (not confirmed), Mastered Confirmed, Fully Mastered (all levels confirmed) or All. </p>
    </>
    )
  }

  const getTextColor = (highlightColor:string) => {
    switch (highlightColor){
      case "#fcd009":
        return "#000";
      default:
        return "#fff";

    }
  }
  if (isMobileClient) {
    return (
      <div className="mobile">
        <section className='bg-primary p-2 clr-white'>
          {upn && currentEmp !== null && (
            <>
              {getH2Heading()}
              {getFilter()}
            </>
          )}
          {!upn && (
            <div className="dis-grid gap-1">
              <div>
                {getH3Heading()}
              </div>
              {getUL()}
              {getFilter()}
            </div>
          )}
        </section>
        {
          skillTree !== null &&
          skillTree.map((skillPath: any, indexT: number) => (
            <>
              <MobileSkillView source='progression' isManager={upn !== undefined} currentUpn={currentUpn}
              employeeProgressions={employeeProgressions} 
              employeeProgressionLevels={employeeProgressionLevels} 
              filterArray={[]} 
              typeFilter={typeFilter}
              filteredSkillGroups={(skillPath as ISkillPath).skillGroups} 
              skillPath={skillPath} 
              bookmarkRemoved={HandleBookmarkRemoved} 
              bookmarkAdded={e => {}} 
              progressionLevelAdded={HandleProgressionLevelAdded} 
              progressionLevelRemoved={HandleProgressionLevelRemoved}
              progressionLevelUpdated={HandleProgressionLevelUpdated} />
            </>
          ))}
      </div>);
  }
  return (
    <>
      <div className="core-container desktop">
        <div className="core-desktop-max-width padded">
          {upn && currentEmp !== null && (
            <>
              {getH2Heading()}
              
              {getFilter()}
            </>
          )}
          {!upn && (
            <div className="ep-desktop-heading-ul-container">
              <div>
                {getH3Heading()}
                {getFilter()}
              </div>
              <div className="m-t-2-5">
                {getUL()} 
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='core-desktop-max-width bottom p-t-1-75 p-b-1-5 sticky-top bg-white'>
        <div className='aln-center'>
          {upn && currentEmp && employeeProgressions.length > 0 && (
            <button className="btn-secondary" onClick={handleMarkReviewed}>Reviewed</button>
          )}
          {upn && currentEmp && currentEmp.lastReviewedDate && (
            <p className="fnt-sz-sml m-t--50">
              Last Reviewed on {new Date(currentEmp.lastReviewedDate).toLocaleDateString()} by {currentEmp.reviewedBy}
            </p>
          )}
        </div>
        <div className='aln-center'>
          <LevelIcon
            iconName='icon-novice'
            iconClassNames={['icon-primary', 'level-icons', 'm-b--75']}
            levelText='Novice'
            levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
            detailText='Learner'
            detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
            iconColor="#0b254d"
          />
        </div>
        <div className='aln-center'>
          <LevelIcon
            iconName='icon-mid-level'
            iconClassNames={['icon-primary', 'level-icons', 'm-b--75']}
            levelText='Mid Level'
            levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
            detailText='Knowledge Competent / Professional'
            detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
            iconColor="#0b254d"
          />
        </div>
        <div className='aln-center'>
          <LevelIcon
            iconName='icon-advanced'
            iconClassNames={['icon-primary', 'level-icons', 'm-b--75']}
            levelText='Advanced'
            levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
            detailText='Mentor'
            detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
            iconColor="#0b254d" 
          />
        </div>
      </div>
      {
        skillTree !== null &&
        skillTree.map((skillPath: any, indexT: number) => (
          <>
            {
              /*
        (skillPath as any).skillLevels &&
        //@ts-ignore
        (skillPath as any).skillLevels.map((sklev: any, index: number) => (
          <><p>{sklev.skillLevelName} {index}</p></>
          ))//ok
*/
                (skillPath as any).skillGroups.map(
                  (sklGrp: any, ind: number) => (
                    <>
                      {
                        //@ts-ignore
                        sklGrp &&
                          sklGrp.skills &&
                          sklGrp.skills.length > -1 &&
                          sklGrp.skills.map((skill: ISkill) => (
                            <>
                              {skill && showSkill(skill) && (
                                <>
                                <SkillDivider
                                  dividerClassNames={[
                                    "p-t--50",
                                    "p-b--50",
                                    "skill-divider-container"
                                ]}
                                headingLevel={4}
                                skillLevels={
                                  (skillPath as any)
                                    .skillLevels as ISkillLevel[]
                                }
                                headingClassNames={[
                                  "clr-white",
                                  "fnt-wght-500",
                                  "m-0",
                                ]}
                                dividerText={getDividerText(
                                  skillPath.skillPathName,
                                  sklGrp.skillGroupName,
                                  skill.skillName
                                )}
                                tooltipContent={skill.skillDescription}
                                backgroundColor={skillPath.highlightColor}
                                skillPathId={sklGrp.skillPathId}
                                isBookmarksSkillDivider={true}
                              />
                              <DesktopSkillGrid
                                borderColor={skillPath.highlightColor}
                                source="progression"
                                progression={employeeProgressions.find(
                                  (ep: any) => ep.skillId === skill.SkillId
                                )}
                                skillLevels={
                                  (skillPath as any)
                                    .skillLevels as ISkillLevel[]
                                }
                                skill={skill}
                                isManager={upn !== undefined} 
                                currentUpn={currentUpn}
                                employeeProgressionLevels={employeeProgressionLevels}
                                progressionLevelAdded={HandleProgressionLevelAdded}
                                progressionLevelRemoved={HandleProgressionLevelRemoved}
                                progressionLevelUpdated={HandleProgressionLevelUpdated}
                                bookmarkRemoved={(bookmark) => {HandleBookmarkRemoved(bookmark)}}
                                bookmarkAdded={e => {}}
                              /></>)}
                            </>
                          ))
                      }
                    </>
                  )
                )
            }
          </>
        )) //ok
      }
    </>
  );
};

export default EmployeeProgression;
